<script setup lang="ts">
import { sysApi } from '@/api'

const { setResources } = useSystemResources()

async function getSystemResources() {
  try {
    const response = await sysApi.getResources()
    setResources(response.data)
  } catch (error) {
    console.error('获取系统资源失败', error)
  }
}

onBeforeMount(() => {
  void getSystemResources()
})
</script>

<template>
  <div class="home-page">
  <!-- 1. 顶部 Banner -->
  <div class="hero-section">
      <HomeBanner />
  </div>

    <!-- 3. 核心产品功能 -->
    <div class="section core-products">
      <div class="section-header section-header--service">
        <div class="section-header__service-en">SERVICE PLATFORM</div>
        <h2 class="section-header__service-title">更专业、更方便的服务介绍</h2>
      </div>
      
      <div class="container">
        <HomeProduct />
      </div>
    </div>

    <!-- 4. 交易流程 -->
    <div class="section flow-section">
      <div class="section-header section-header--flow">
        <div class="section-header__flow-en">ACCESS PROCESS</div>
        <h2 class="section-header__flow-title">接入流程</h2>
      </div>
      <div class="container">
        <HomeFlow />
      </div>
    </div>

    <!-- 5. 我们的优势 -->
    <div class="section advantages-section">
      <div class="section-header section-header--advantage">
        <div class="section-header__advantage-en">ADVANTAGE</div>
        <h2 class="section-header__advantage-title">我们的优势</h2>
      </div>
      <div class="container">
        <HomeAdvantage />
      </div>
    </div>

    <!-- 6. 新闻资讯 -->
    <div class="section news-section">
      <div class="section-header section-header--news">
        <div class="section-header__en">INFORMATION</div>
        <h2 class="section-header__title">新闻资讯</h2>
      </div>
      <div class="container">
        <HomeNews />
      </div>
    </div>

    <!-- 7. 合作伙伴 -->
    <div class="section partners-section">
      <div class="section-header section-header--partner">
        <div class="section-header__partner-en">PARTNER</div>
        <h2 class="section-header__partner-title">合作伙伴</h2>
        <p class="section-header__partner-subtitle">官方合作，产品丰富，更加保障安全</p>
      </div>
      <div class="container">
        <HomePartners />
      </div>
    </div>

    <!-- 8. 关于我们 -->
    <div class="section about-section">
      <div class="section-header section-header--about">
        <div class="section-header__about-en">ABOUT US</div>
        <h2 class="section-header__about-title">关于我们</h2>
      </div>
      <div class="container">
        <HomeAbout />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home-page {
  background: #fff;
}

.container {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
  position: relative;
}

.hero-section {
  margin-bottom: 72px;
  background: linear-gradient(180deg, #d9f7ff 0%, #fff 100%);
}

/* 通用 Section Header */
.section {
  padding: 60px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
  
  .icon {
    font-size: 24px;
    margin-bottom: 5px;
  }
  
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #0E2036;
  }
  
  .subtitle {
    font-size: 16px;
    color: #5C7A9E;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-top: 10px;
  }
  
  .more {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    display: flex;
    align-items: center;
    
    .el-icon {
      margin-left: 5px;
    }
  }
}
.news-section {
  padding-top: 52px;
  padding-bottom: 56px;
}

.core-products {
  padding-top: 8px;
  padding-bottom: 42px;
}

.flow-section {
  padding-top: 52px;
  padding-bottom: 0;
}

.advantages-section {
  padding-top: 24px;
  padding-bottom: 62px;
}

.section-header--flow {
  min-height: 74px;
  margin-bottom: 24px;

  .section-header__flow-en {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    color: #edf5ff;
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    white-space: nowrap;
    pointer-events: none;
  }

  .section-header__flow-title {
    position: relative;
    z-index: 1;
    margin: 0;
    padding-top: 20px;
    color: #12233b;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
  }
}

.section-header--service {
  min-height: 74px;
  margin-bottom: 24px;

  .section-header__service-en {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    color: #edf5ff;
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    white-space: nowrap;
    pointer-events: none;
  }

  .section-header__service-title {
    position: relative;
    z-index: 1;
    margin: 0;
    color: #12233b;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
    padding-top: 20px;
  }
}

.section-header--advantage {
  min-height: 74px;
  margin-bottom: 24px;

  .section-header__advantage-en {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    color: #edf5ff;
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    white-space: nowrap;
    pointer-events: none;
  }

  .section-header__advantage-title {
    position: relative;
    z-index: 1;
    margin: 0;
    padding-top: 20px;
    color: #12233b;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
  }
}

.section-header--news {
  min-height: 74px;
  margin-bottom: 24px;

  .section-header__en {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    color: #edf5ff;
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    white-space: nowrap;
    pointer-events: none;
  }

  .section-header__title {
    position: relative;
    z-index: 1;
    margin: 0;
    padding-top: 20px;
    color: #192c43;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
  }
}

.partners-section {
  padding-top: 42px;
  padding-bottom: 58px;
  background: #fff;

  .container {
    width: min(1276px, calc(100% - 134px));
  }
}

.section-header--partner {
  min-height: 86px;
  margin-bottom: 24px;

  .section-header__partner-en {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    color: #edf5ff;
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    white-space: nowrap;
    pointer-events: none;
  }

  .section-header__partner-title {
    position: relative;
    z-index: 1;
    margin: 0;
    padding-top: 20px;
    color: #12233b;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
  }

  .section-header__partner-subtitle {
    position: relative;
    z-index: 1;
    margin: 6px 0 0;
    color: #6382a8;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
  }
}

@media (max-width: 900px) {
  .partners-section {
    .container {
      width: min(1180px, calc(100% - 48px));
    }
  }
}

.about-section {
  padding-top: 18px;
  padding-bottom: 38px;
  background: #fff;
}

.section-header--about {
  min-height: 74px;
  margin-bottom: 24px;

  .section-header__about-en {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    color: #edf5ff;
    font-size: 38px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    white-space: nowrap;
    pointer-events: none;
  }

  .section-header__about-title {
    position: relative;
    z-index: 1;
    margin: 0;
    padding-top: 20px;
    color: #12233b;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
  }
}

</style>
